import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Row, Button, Table, Switch } from 'antd';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getSchoolConfigs, updateSchoolConfig } from './ecoleConfig.reducer';
import { getEcole } from '../ecole/ecole.reducer';
import { IConfigurations } from 'app/shared/model/configurations.model';

const PEDAGOGIE_MENU_ENABLED = 'PEDAGOGIE_MENU_ENABLED';
const PEDAGOGIE_ENABLED_LEGACY = 'PEDAGOGIE_ENABLED';
const PEDAGOGIE_MENU_LABEL = 'Menu Pédagogie';

const isPedagogieMenuConfig = (configKey?: string) => configKey === PEDAGOGIE_MENU_ENABLED || configKey === PEDAGOGIE_ENABLED_LEGACY;

export const Configurations = (props: RouteComponentProps<{ ecoleId: string }>) => {
  const { match } = props;

  const dispatch = useAppDispatch();
  const configurations = useAppSelector(state => state.ecoleConfig.entities);

  useEffect(() => {
    dispatch(getEcole(match.params.ecoleId));
    dispatch(getSchoolConfigs(match.params.ecoleId));
  }, [dispatch, match.params.ecoleId]);

  const handlePedagogieToggle = (checked: boolean, config: IConfigurations) => {
    dispatch(updateSchoolConfig({ ...config, value: String(checked) }));
  };

  const columns = [
    {
      title: <Translate contentKey="configuration.appConfig.key">KEY</Translate>,
      dataIndex: 'configKey',
      key: 'configKey',
      render: value => (isPedagogieMenuConfig(value) ? PEDAGOGIE_MENU_LABEL : value),
    },
    {
      title: <Translate contentKey="configuration.appConfig.value">VALUE</Translate>,
      dataIndex: 'value',
      key: 'value',
      render: (_, record) =>
        isPedagogieMenuConfig(record.configKey) ? (
          <Switch checked={record.value === 'true'} onChange={checked => handlePedagogieToggle(checked, record)} />
        ) : (
          record.value
        ),
    },
    {
      title: 'OPTION',
      dataIndex: 'id',
      key: 'id',
      render: (id, record) =>
        isPedagogieMenuConfig(record?.configKey) ? null : (
          <div>
            <Row className="justify-content-center">
              <Button type="primary" style={{ height: 'auto', width: 'auto' }} data-cy="entityEditButton">
                <Link to={`${match.url}/${id}/edit`} id="jh-create-entity" data-cy="entityCreateButton">
                  <FontAwesomeIcon icon="pencil-alt" />
                  &nbsp; <Translate contentKey="configuration.edit">Edit</Translate>
                </Link>
              </Button>
              &nbsp;
            </Row>
          </div>
        ),
    },
  ];

  return (
    <div>
      <h2 id="configuration-heading" data-cy="ClasseHeading">
        <Translate contentKey="configuration.title">Configuration</Translate>
      </h2>
      <div className="table-responsive">
        <Table columns={columns} dataSource={configurations} rowKey="id" pagination={false} scroll={{ y: 400 }} />
      </div>
    </div>
  );
};

export default Configurations;
